export var SnackbarVariant;
(function (SnackbarVariant) {
    /**
     * @deprecated
     */
    SnackbarVariant["DEFAULT"] = "DEFAULT";
    SnackbarVariant["SIMPLE"] = "SIMPLE";
    SnackbarVariant["COMPLEX"] = "COMPLEX";
})(SnackbarVariant || (SnackbarVariant = {}));
//# sourceMappingURL=variants.js.map